/* eslint-disable complexity */

// var site = site || {};
(function ($) {
  Drupal.behaviors.filterableProductsGridItemV1 = {
    imagePattern: 'mac_sku_PRODUCT_CODE_640x600_FILTER_VALUE',
    imageExtension: 'jpg',
    itemInlineTemplatePath: 'filterable_products_grid_partial_item_v1',
    prefilterSkus: [],
    nodes: {},
    selector: {
      prefilter: '.js-filterable-products__grid-item-prefilter',
      grid: '.js-filterable-products__grid',
      item: '.js-filterable-products__grid-item',
      contentItem: '.js-filterable-content__grid-item',
      container: '.js-filterable-products-block',
      ctaLink: '.js-filterable-products__grid-item--cta-url',
      productLink: '.js-filterable-products__grid-item--link',
      itemimage: '.js-filterable-products__grid-item--main-image'
    },

    cssClass: {
      hasResults: 'filterable-products-block--has-results'
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.setup(context);
    },

    setup: function (context) {
      var self = this;
      var $grids = $(self.selector.grid, context);

      $grids.each(function () {
        var $this = $(this);

        self.getDom($this);
        self.setEvents($this);
        self.populateSkusArray($this);
        if (!!$this.data('ctaText')) {
          $this.nodes.$ctaLink.once('cta-text').html($this.data('ctaText'));
        }
        self.setRandomImageAvailable($this);
      });
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$items = $(self.selector.item, $that);
      $that.nodes.$contentItem = $(self.selector.contentItem, $that);
      $that.nodes.$ctaLink = $(self.selector.ctaLink, $that.nodes.$items);
      $that.nodes.$productLink = $(self.selector.productLink, $that.nodes.$items);
      $that.nodes.$itemMainImage = $(self.selector.itemimage, $that.nodes.$items);
      $that.nodes.$container = $that.closest(self.selector.container);
      $that.nodes.$itemInline = $(
        'script.inline-template[path="' + self.itemInlineTemplatePath + '"]',
        $that.nodes.$container
      );
    },

    populateSkusArray: function ($that) {
      var self = this;
      var $prefilterSkus = $(self.selector.prefilter, self.nodes.$grid);

      $that.prefilterSkus = [];
      $prefilterSkus.filter(function () {
        $that.prefilterSkus.push($(this).data('skuBaseId'));
      });
    },

    getItemHtml: function (productData) {
      var self = this;
      var template_data = site.templates[self.itemInlineTemplatePath];
      var partials = {};

      if (!template_data) {
        return;
      }
      var templateHtml = template_data.content;

      if (!_.isUndefined(template_data.partials)) {
        $.each(template_data.partials, function (key, name) {
          if (_.isUndefined(site.templates[name])) {
            throw new Error('The partial ' + name + ' cannot be found');
          }
          partials[key] = site.templates[name].content;
        });
      }

      return Mustache.render(templateHtml, productData, partials);
    },

    getAvailableImage: function ($this, randomValues) {
      var availableValues = $this.data('availableRandomImages');

      availableValues = _.intersection(randomValues, availableValues);

      return availableValues[_.random(availableValues.length - 1)];
    },

    processTags: function (tagsData) {
      if (typeof tagsData !== 'string') {
        return [];
      }
      var newData = tagsData.replace(/['`~!@#$%^&*()|+=?;:'".<>\{\}\[\]\\\/]/gi, '').toLowerCase();
      // Loop through our tags, split them by comma, then trim the whitespace
      var tags = _.map(newData.split(','), $.trim);

      return tags;
    },

    setRandomImageAvailable: function ($that) {
      var self = this;

      if (!$that.nodes.$container.data('hasRandomization')) {
        return;
      }
      $that.nodes.$items.once('random-images-available').each(function () {
        var $item = $(this);

        if (!$item.data('attributes').tags && !$item.data('attributes').skuTags) {
          return;
        }
        var tags = self.processTags($item.data('attributes').tags);
        var skuTags = self.processTags($item.data('attributes').skuTags);
        var availableRandomImages = tags.concat(skuTags);
        var $images = $item.find($that.nodes.$itemMainImage);

        $images
          .data('availableRandomImages', availableRandomImages)
          .attr('data-available-random-images', availableRandomImages);
      });
    },

    swapImage: function ($that, filterData) {
      var self = this;
      var src = '';
      var randomize = !!filterData.randomValues;
      $that.nodes.$itemMainImage.each(function () {
        var $image = $(this);
        if (!!filterData.forceSwap && !!$image.data('forceSwap')) {
          // forceSwap come true when new items are added on deferred sku's
          // we only need to randomise once per item on page load.
          return;
        }
        filterData.forceSwap ? $image.data('forceSwap', filterData.forceSwap) : '';

        var pattern = self.imagePattern;
        var filterValue = filterData.filterValue;
        if (randomize) {
          filterValue = self.getAvailableImage($image, filterData.randomValues);
        } else {
          // if there is no randomize we still check for available filter values
          filterValue = self.getAvailableImage($image, [filterValue]) || [];
        }
        if (!filterValue || filterValue.length < 1) {
          // no need to replace the src this item will be filtered out
          return;
        }
        pattern = pattern.replace('PRODUCT_CODE', $image.data('productCode'));
        pattern = pattern.replace('FILTER_VALUE', filterValue);
        src = filterData.imagePath + '/' + pattern + '.' + self.imageExtension;
        if ($image.hasClass('lazyload')) {
          $image.data('src', src).attr('data-src', src);
        } else {
          $image.data('src', src).attr('data-src', src).attr('src', src);
        }
        if ($that.data('gridLayout') === 'parallax_grid') {
          $image.closest('.js-filterable-products-defered-sku').css({ display: 'block' });
        }
      });
    },
    setDefaultOrder: function ($that) {
      $that.nodes.$items.add($that.nodes.$contentItem).map(function (i, item) {
        var count = i + 1;

        $(item).data('default-order', count).attr('data-default-order', count);
      });
      if (!!$that.data('isotope')) {
        $that.isotope('updateSortData');
        $that.isotope('reloadItems');
      }
    },

    setEvents: function ($that) {
      var self = this;

      $that.nodes.$container
        .on('filterable_products:swapImage', function (e, eventData) {
          self.swapImage($that, eventData);
        })
        .on('filterable_products:randomSwapImage', function (e, eventData) {
          self.swapImage($that, eventData);
        })
        .on('filterable_products:resetImage', function () {
          self.resetImage($that);
        })
        .on('filterable_products:newItems', function () {
          self.getDom($that);
          if (!!$that.data('ctaText')) {
            $that.nodes.$ctaLink.once('cta-text').html($that.data('ctaText'));
            self.setCtaAction($that);
          }
          self.setDefaultOrder($that);
        });
      $that.on('arrangeComplete', function () {
        if ($that.data('hasDeferedSkus')) {
          $that.once('deferred', function () {
            self.loadDefferedSkus($that);
          });
        }
      });
      $that.on('mixEnd', function (e, state) {
        if ($that.data('hasDeferedSkus')) {
          $that.once('deferred', function () {
            self.loadDefferedSkus($that);
          });
        }
      });
      self.setCtaAction($that);
    },

    setCtaAction: function ($that) {
      var self = this;

      if ($that.nodes.$container.hasClass(self.cssClass.hasResults)) {
        self.setResultsLink($that);
      } else {
        self.setSppLink($that);
      }
      $that.nodes.$productLink.once().on('click', function (e) {
        if (
          $(this).hasClass('filter-dependent') &&
          ($that.hasClass('parallax-initialized') ||
            !$that.hasClass('filterable-products__grid--filtered'))
        ) {
          e.preventDefault();
        }
      });
    },

    setResultsLink: function ($that) {
      var self = this;

      $that.nodes.$ctaLink.each(function () {
        var $ctaLink = $(this);
        var $item = $ctaLink.closest($that.nodes.$items);
        var skuBaseId = $item.data('skuBaseId');
        var $productLinks = $item.find($that.nodes.$productLink);

        $ctaLink.once('cta-action').on('click', function (e) {
          e.preventDefault();
          self.showResults($that, skuBaseId);
        });
        $productLinks.once('cta-action').on('click', function (e) {
          e.preventDefault();
          if (
            $(this).hasClass('filter-dependent') &&
            !$that.hasClass('filterable-products__grid--filtered')
          ) {
            return;
          }
          self.showResults($that, skuBaseId);
        });
      });
    },

    showResults: function ($that, skuBaseId) {
      if ($that.nodes.$container.hasClass('showResults-loading')) {
        return;
      }
      $that.nodes.$container
        .addClass('showResults-loading')
        .trigger('filterable_products:switchView', {
          view: 'showResults',
          sku: skuBaseId
        });
    },

    setSppLink: function ($that) {
      $that.nodes.$ctaLink.each(function () {
        var $ctaLink = $(this);
        var $item = $ctaLink.closest($that.nodes.$items);
        var skuBaseId = $item.data('skuBaseId');
        var $productLinks = $item.find($that.nodes.$productLink);

        if ($ctaLink.attr('href').indexOf('?shade=') === -1) {
          var skuData = prodcat.data.getSku(skuBaseId);

          if (!!skuData) {
            var processedShadename = skuData.SHADENAME.replace(/\s/g, '_');

            processedShadename = encodeURIComponent(processedShadename).replace(
              /[!'()*]/g,
              function (c) {
                return '%' + c.charCodeAt(0).toString(16);
              }
            );
            var shadeRoute = $ctaLink.attr('href') + '?shade=' + processedShadename;

            $ctaLink.attr('href', shadeRoute);
            $productLinks.attr('href', shadeRoute);
          }
        }
      });
    },

    resetImage: function ($that) {
      $that.nodes.$itemMainImage.each(function () {
        var $image = $(this);
        $image.data('src', $image.data('originalSrc')).attr('data-src', $image.data('originalSrc'));
        if (!$image.hasClass('lazyload')) {
          $image.attr('src', $image.data('originalSrc'));
        }
      });
    },

    cleanDropSkus: function (dropSkus) {
      if (!!dropSkus) {
        dropSkus = dropSkus.replace(/\s+/g, '');
        dropSkus = dropSkus.split(',');
      }

      return dropSkus;
    },
    loadDefferedSkus: function ($that) {
      var self = this;
      var $deferedSkusItems = $that.nodes.$items.filter(
        '[data-defered-skus="true"]:not(.defered-skus-loaded)'
      );
      var dropSkus = self.cleanDropSkus($that.data('dropSkus'));

      $deferedSkusItems.each(function () {
        var $item = $(this);

        $item.addClass('defered-skus-loaded');
        var productId = $item.data('productId');
        var productData = productId ? prodcat.data.getProduct(productId) : {};
        var loadedSkuBaseId = $item.data('skuBaseId');
        var $itemHtml = $();
        var $deferedSkusHtml = $();
        var skuAsProduct = $item.data('skuAsProduct') || false;

        // only loop skus for PROD ID's if the SKU ID was used the html is already present
        if (skuAsProduct === false) {
          productData.skus.forEach(function (skuData) {
            if (!!dropSkus && $.inArray(skuData.SKU_ID, dropSkus) !== -1) {
              return;
            }
            var productSkuData = {};

            if (
              loadedSkuBaseId !== skuData.SKU_BASE_ID &&
              $that.prefilterSkus.indexOf(skuData.SKU_BASE_ID) === -1
            ) {
              productSkuData = $.extend({}, productData, skuData);
              // keep .hide() in place it's required for the sort / filter animation don't change to .hidden
              $itemHtml = $(self.getItemHtml(productSkuData)).addClass(
                'js-filterable-products-defered-sku'
              );
              if ($that.data('gridLayout') !== 'parallax_grid') {
                $itemHtml.hide();
              }
              $deferedSkusHtml = $deferedSkusHtml.add($itemHtml);
            }
          });
          $deferedSkusHtml.insertAfter($item);
          if (
            $.inArray('SKU' + loadedSkuBaseId, dropSkus) !== -1 ||
            $that.prefilterSkus.indexOf(loadedSkuBaseId) !== -1
          ) {
            // if product defaultSku was used as prefilter item as well, we need to remove it after we append the other skus
            // same if the defaultSku was set in the drop_skus field
            $item.remove();
          }
          $that.nodes.$container.trigger('filterable_products:newItems');
          self.setRandomImageAvailable($that);
        }
      });
    },
    attached: false
  };
})(jQuery);
